import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink, ITranslations } from "@/types"

export interface IGetTermsAndConditionsDto {
    termsAndConditions?: ITranslations
    links: IApiLink[]
}

export interface IUpdateTermsAndConditions {
    termsAndConditions: ITranslations
}

export default class TermsAndConditions {
    termsAndConditions: ITranslations
    linkUpdate?: IApiLink

    constructor(dto: IGetTermsAndConditionsDto) {
        this.termsAndConditions = dto.termsAndConditions || {}
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsTermsAndConditions && lnk.rel === ApiLinkRel.upsert)
    }
}
